import React, { createContext, useContext, useState } from 'react';
import { useSelector } from 'react-redux';

const FormContext = createContext();

export const useFormData = () => useContext(FormContext);

export const FormProvider = ({ children }) => {
    const userData = useSelector((state) => state.user.user);
    const [resumed, setResumed] = useState(false); 
  const [formData, setFormData] = useState({
    applicationId: null,
    mobileNo: '',
    email: '',
    profession: '',
    gstin: '',
    panNumber: '',
    status: '',
    fundRequirement: 0,
    endUseOfFund: '',
    securityOffered: '',
    descriptionOfSecurity: '',
    udyamRegistrationNo: '',
    entityType: userData?.UserType,
    borrowerType: userData?.BorrowerType,
    steps: '',
    totalSalesCurrentYear: 0,
    userId: userData?.ID
  });
  const [files, setFiles] = useState({
    panCard: [],
    AadharCard: [],
    orderCopy: null,
    contractCopy: null,
    certification: null,
    creditRating: null,
    salarySlips: [],
    joiningLetter: null,
    borrowerPanCard: null,
    moa: null,
    aoa: null,
    listOfDirector: null,
    shareholding: null,
    itr: [],
    balanceSheet: [],
    partnershipDeed: null,
    listOfPatner: null,
    incorporationDateProof: null,
    applicantPan: null,
    applicantAadhar: null,
    coApplicantPan: null,
    coApplicantAadhar: null,
    applicantForm16: null,
    coApplicantForm16: null,
    bankStatement: [],
    slLoan: [],
    gstDocx: null,
    as26: null,
    aadharCard: [],
    applicantItr: [],
    coApplicantItr: [],
  });
  const updateFormData = (newData) => {
    setFormData(prev => ({
      ...prev,
      ...newData
    }));
  };

  return (
    <FormContext.Provider value={{ formData, updateFormData ,resumed,setResumed,files, setFiles}}>
      {children}
    </FormContext.Provider>
  );
};
